import { jsx } from "react/jsx-runtime";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { validateTidalLicense } from "../../base/index.js";
function SettingsOutlined(props) {
  return /* @__PURE__ */ jsx(
    SettingsOutlinedIcon,
    {
      "data-testid": "SettingsOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "SettingsOutlined",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
SettingsOutlined.tidalIconMeta = {
  categories: "common,navigation",
  name: "SettingsOutlined"
};
validateTidalLicense();
export {
  SettingsOutlined
};
//# sourceMappingURL=SettingsOutlined.js.map
